<template>
  <div id="app">
    <ThemeProvider :theme="theme">
      <Component :is="this.$route.meta.layout || 'div'">
        <RouterView />
      </Component>
    </ThemeProvider>
  </div>
</template>

<script src="https://kit.fontawesome.com/b433a84edd.js"></script>
<script src="./assets/js/jquery.js" charset="utf-8"></script>
<script src="./assets/js/popper.js" charset="utf-8"></script>
<script src="./assets/js/bootstrap.js" charset="utf-8"></script>
<script src="./assets/js/functions.js" charset="utf-8" defer></script>

<script>
import { ThemeProvider } from "vue-styled-components";
import theme from "./styles/theme";

export default {
  name: "App",
  components: {
    ThemeProvider
  },
  data() {
    return {
      theme
    };
  },
  channels: {
    AlertChannel: {
      received(data) {
        alert(`Alerta recebido por: ${data.user_name}`);
        this.$router.push({
          name: "Alerts",
          params: { showAlert: data.id }
        });
      }
    }
  },
  methods: {
    subscribeAlertChannel() {
      this.$cable.subscribe({
        channel: "AlertChannel",
        institution_id: this.$store.state.user.currentUser.institution_id
      });
    }
  },
  computed: {
    isOperatorLoggedin() {
      return this.$store.state.user.userRole === "operator";
    }
  },
  watch: {
    isOperatorLoggedin() {
      this.subscribeAlertChannel();
    }
  }
};
</script>

<style lang="scss">
@import "./assets/css/style.css";
@import "./design";

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}

strong {
  font-weight: bold !important;
}
</style>
